import { Fragment } from "react"

type LinkifyProps = {
  content?: string
  linkDisplayText?: string
  sessionId?: string | null
}


const Linkify = ({ content, linkDisplayText, sessionId }: LinkifyProps) => {
  if (!content) {
    return <Fragment></Fragment>;
  }

  content = sessionId
    ? content.replaceAll("{aiva.conversation_id}", sessionId)
    : content;

  // Combined regex to match Markdown links, plain URLs, bold text, italic text, and headers
  // The regex prioritizes Markdown link syntax before plain URLs, bold, italic text, and headers
  const combinedRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s]+)|\*\*([^\*]+)\*\*|\*([^\*]+)\*|_([^_]+)_|###\s([^\n]+)/g;

  const htmlContent = content.replace(
    combinedRegex,
    (match, markdownText, markdownUrl, plainUrl, boldText, italicTextAsterisk, italicTextUnderscore, headerText) => {
      // If it's a Markdown link
      if (markdownUrl) {
        return `<a href="${markdownUrl}" target="_blank" rel="noreferrer">${markdownText}</a>`;
      }
      // If it's a plain URL
      if (plainUrl) {
        return `<a href="${plainUrl}" target="_blank" rel="noreferrer">${
          linkDisplayText ? linkDisplayText : plainUrl
        }</a>`;
      }
      // If it's bold text
      if (boldText) {
        return `<strong>${boldText}</strong>`;
      }
      // If it's italic text with asterisks
      if (italicTextAsterisk) {
        return `<em>${italicTextAsterisk}</em>`;
      }
      // If it's italic text with underscores
      if (italicTextUnderscore) {
        return `<em>${italicTextUnderscore}</em>`;
      }
      // If it's a header (###)
      if (headerText) {
        return `<h3>${headerText}</h3>`;
      }
      return match; // Return the original match if neither case applies (should not happen in this scenario)
    }
  );

  // Render the content as HTML inside the Fragment
  return (
    <div className="message-text" dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};


export default Linkify
